import { render, staticRenderFns } from "./MyStaffTable.vue?vue&type=template&id=e71f0964&scoped=true"
import script from "./MyStaffTable.vue?vue&type=script&lang=js"
export * from "./MyStaffTable.vue?vue&type=script&lang=js"
import style0 from "./MyStaffTable.vue?vue&type=style&index=0&id=e71f0964&prod&scoped=true&lang=css"
import style1 from "./MyStaffTable.vue?vue&type=style&index=1&id=e71f0964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71f0964",
  null
  
)

export default component.exports